import React, { FC } from "react";
import Header from "../layouts/header";

type ScreenWrapperProps = {
  title?: string;
  showBackBtn?: boolean;
  searchFunction?: () => void;
  backFunction?: () => void;
  clearSearchFunction?: () => void;
  data?: any[];
  shouldBlur?: boolean;
  children: React.ReactNode;
};

const ScreenWrapper: FC<ScreenWrapperProps> = ({
  children,
  shouldBlur = false,
}) => {
  const blurClass = shouldBlur ? "filter blur-md pointer-events-none" : "";

  return (
    <div className={`h-screen flex-1 flex flex-col w-full overflow-x-hidden relative bg-white items-center ${blurClass}`}>
      <div className={`w-full fixed top-0 z-10 ${blurClass}`}>
        <Header />
      </div>
      <div className="min-h-full lg:py-8 py-10 overflow-y-scroll z-0 relative my-10 w-full">
        {children}
      </div>
    </div>
  );
};

export default ScreenWrapper;
